<template>
	<div id="post-settings" v-if="step > 1">
		<div v-if="showMediaManager">
			<media-manager
				:picsInGallery="groupCarouselContent"
				@receiveMedias="addPictures($event)"
				@closeTabs="closeTabs()"
				:maxItemSelected="1"
			/>
		</div>
		
		<b-modal
			@hide="clearNewCategory"
			modal-class="full-white"
			ref="modalCategory"
			id="modalCategory"
			title="Nova Categoria"
			hide-footer
			hide-header-close
			centered
		>
			<form @submit="handleNewCategory">
				<div class="row">
					<div class="col-12 form-group">
						<label for="newCategory">Digite a categoria</label>
						<input
							type="text"
							v-model="newCategory.title"
							id="newCategory"
							class="form-control"
						/>
						<span class="error-message" v-if="newCategory.error">
							<small>{{ newCategory.textError }}</small>
						</span>
					</div>
					<div class="col-12 text-right">
						<button type="submit" class="btn btn-primario py-2">
							Criar
						</button>
					</div>
				</div>
			</form>
		</b-modal>
		<div class="row">
			<div class="col-12">
				<h5
					v-if="contentPost[0].frameContent[0].frameContent && contentPost[0].frameContent[0].frameType == 'title' "
					v-html="contentPost[0].frameContent[0].frameContent"
				></h5>
			</div>
			<div class="col-12">
				<label>Capa</label>
				<template >
				<div style="display: flex;">
					<div style="display: flex;overflow-x: auto">
						<ul style="display: flex; width: 100vw; height: 90px; padding-left: 5px;">
							<button
								@click="handleOpenMediaManager"
								class="box-sendfile text-center d-flex align-items-center justify-content-center cursor-pointer"
							>
								<div class="w-100">
									<i class="fal fa-upload w-100"></i>
									<span class="w-100">Enviar arquivo</span>
								</div>
							</button>

							<li
								v-for="(image, index) in groupCarouselContent"
								:key="index"
								:index="index"
								@click="mainImage(image)"
								class="d-flex align-items-center photo"
								style="padding:5px"
							>
								<img
									:class="[isSelected(image) ? 'active' : '']"
									class="select"
									:src="mountImageUrl(image)"
									:alt="index"
									style="border-radius: 8px; height:90px"
								/>
							</li>
						</ul>
					</div>
				</div>
				</template>
			</div>
			<div class="col-12 col-md-4 mb-2">
				<label>Data de publicação</label>
				<vuejs-datepicker
					mode="single"
					v-model="dates.display_date"
					color="purple"
					:language="ptBR"
					:input-props="{
						class: 'input-picker form-control',
					}"></vuejs-datepicker>
			</div>
			<div class="col-12 col-md-auto align-self-end mb-2">
				<input type="checkbox" id="showDate" v-model="dates.showDate" />
				<label class="pointer" for="showDate"
					>Exibir data de publicação</label
				>
			</div>
			<div class="col-12 mb-2">
				<label>Postar conteúdo em</label>
				<div class="list-pages py-2 d-flex align-items-center">
					<span
						class="list-pages-item mr-3"
						:class="pages.length == 0 ? 'item-active' : ''"
						@click="cleanActivePage()"
						>Nenhum</span
					>
					<span
						class="list-pages-item mr-3"
						:class="checkActivePage(item.id)"
						v-for="item in getListPagesSimplified"
						:key="item.title"
						@click="handleActivePage(item)"
						>{{ item.title }}</span
					>
				</div>
			</div>
			<div class="col-12">
				<label>Categorias</label>
				<categories
                    :activeCategories="categories"
                    @checkActiveCategories="checkActiveCategories($event)"
                    @handleActiveCategory="handleActiveCategory($event)"
                    @removeCategory="removeCategory($event)"
                />
			</div>

			<div class="col-12">
				<hr />
			</div>
			<div class="col-12 text-right">
				<span
					class="pointer"
					@click="showAdvancedSettings = !showAdvancedSettings"
				>
					<i class="fal fa-cog"></i>
				</span>
			</div>
			<template v-if="showAdvancedSettings">
				<div class="col-12 mb-3">
					<label for>Localização</label>
					<input
						class="form-control default_input"
						placeholder="Pesquisar..."
						v-model="searchResponse.search"
						v-gmaps-searchbox="searchResponse"
					/>
				</div>
				<div class="col-12 mb-3">
					<label for>Resumo</label>
					<textarea
						v-model="summary"
						class="boxsizingBorder form-control"
						maxlength="200"
						name
						id="resumeText"
						cols="42"
						rows="3"
					/>
				</div>
				<div class="col-12 mb-3">
					<label for>Destacar na página principal</label>
					<div>
						<div
							class="toggle-button d-inline-block pointer"
							@click="isAtHome = !isAtHome"
						>
							<span v-if="isAtHome">
								<i class="fas fa-star fa-2x"></i>
							</span>
							<span v-else>
								<i class="far fa-star fa-2x"></i>
							</span>
						</div>
					</div>
				</div>
				<div class="col-12 mb-3 pb-5">
					<label for>Tags</label>
					<vue-tags-input
						v-model="tag"
						:tags="tags"
						:placeholder="'Digite a tag e aperte enter'"
						@tags-changed="(newTags) => (tags = newTags)"
						:add-on-key="[13, ',', ';']"
						:maxlength="60"
					/>
				</div>
			</template>
			<div class="w-auto btn-fixed">
				<div v-if="isSchedulePost === true">
				<button  class="btn btn-primario py-3 px-5" :disabled="savingSketch" @click="handleToSave()"><span v-if="savingSketch"><i class="fal fa-spinner fa-spin"></i></span> Agendar </button>
				<button class="btn btn-primario py-3 px-5" :disabled="savingSketch" @click="handleToSave('now')"><span v-if="savingSketch"><i class="fal fa-spinner fa-spin"></i></span> Publicar</button>
				</div >
				<button v-else class="btn btn-primario py-3 px-5" :disabled="savingSketch" @click="handleToSave()"><span v-if="savingSketch"><i class="fal fa-spinner fa-spin"></i></span> Publicar</button>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from "axios";

	import VueTagsInput from "@johmun/vue-tags-input";
	import { Carousel3d, Slide } from "vue-carousel-3d";
	import { mapGetters, mapMutations, mapState } from "vuex";
	import vuejsDatepicker from 'vuejs-datepicker';
	import { ptBR } from 'vuejs-datepicker/dist/locale'
	import apiMixins from "@/mixins/apiMixins";
	import uploadFiles from "@/mixins/uploadFiles";
	import BaseImage from "@/components/atoms/BaseImage";
	import FileAdd from "../molecules/FileAdd.vue";
    import Categories from '../molecules/Categories.vue';
	import MediaManager from './MediaManager.vue';
	var moment = require("moment");
	export default {
		data() {
			return {
				showMediaManager: false,
				categories: [],
				customImagesCarousel: [],
				dates: { },
				errors: {
					pages: false,
				},
				getListPagesSimplified: [],
				isAtHome: 0,
				loadingMainImage: false,
				newCategory: {
					title: "",
					error: false,
					textError: "",
				},
				newPlace: {},
				newThumbnail: {
					height: null,
					mainImage: null,
					width: null,
				},
				pages: [],
				saveCompleted: false,
				savingSketch: false, //Impede que o botao salvar seja clicado enquanto o rascunho ainda estiver salvando
				searchResponse: {
					search: "",
					place: "",
				},
				showAdvancedSettings: false,
				sketch: 0,
				autoSave:0,
				startPlace: "",
				summary: "",
				tag: "",
				tags: [],
				visible: 0,
				ptBR: ptBR,
				modalSchedulePost: {'show':false,
									'change':0},
				isSchedulePost:false,
			};
		},
		props: {
			postId: {
				required: true,
			},
			deletedFrames: {
				type: Array,
				required: false,
			},
			postType:{
				type: String,
				required: true,
			},
			step:{
				type: Number,
				required: false,
			},
		},
		components: {
			Carousel3d,
			Slide,
			VueTagsInput,
			vuejsDatepicker,
			BaseImage,
			FileAdd,
            Categories,
			MediaManager
		},
		mixins: [apiMixins, uploadFiles],
		created(){
			this.ROOT_API = process.env.ROOT_API;
		},
		mounted() {
			//this.choiceSave();
		},
		watch: {
			searchResponse: {
				handler: function (val, oldVal) {
					if (this.searchResponse.place) {
						const placeResult = {
							address_components: this.searchResponse.place
								.address_components,
							address: this.searchResponse.place.formatted_address,
							geometry: {
								location: {
									lat: this.searchResponse.place.geometry.location.lat(),
									lng: this.searchResponse.place.geometry.location.lng(),
								},
							},
						};
						this.newPlace = placeResult;
					}
				},
				deep: true,
			},
			'dates.display_date' : {
				handler: function () {
					this.modalSchedulePost.change ++;
					 if(this.postType === "post" && this.step != 3  && !this.modalSchedulePost.show && this.modalSchedulePost.change > 2 ){
						this.modalSchedulePost.show = true;
						this.isSchedulePost  = this.validateSchedulePost()
					}
				},
				deep: true,
			},
		},
		computed: {
			...mapState("dashboardModule", {
				totalPost: (state) => state.activePost,
				contentPost: (state) => state.activePost.content,
				siteId: (state) => state.siteData.id,
				updatePostEditorStatus:(state)=>state.updatePostEditorStatus,
			}),
			...mapGetters("dashboardModule", [
				"allPostActiveImages",
				"getListPages",
				"getCategories",
			]),
			mainImagePosition() {
				const index = this.groupCarouselContent.findIndex(
					(image) => image == this.totalPost.thumbnail.mainImage

				);
				return index >= 0 ? index + 1 : 0;
			},
			groupCarouselContent() {
				let grouped = [
					...this.customImagesCarousel,
					...this.allPostActiveImages,
				];
				let hasMainImage = grouped.some(
					(image) => image == this.totalPost.thumbnail.mainImage
				);
				if (!hasMainImage && this.totalPost.thumbnail.mainImage) {
					grouped.push(this.totalPost.thumbnail.mainImage);
				}
				return grouped;
			},
		},
		methods: {
      ...mapMutations("dashboardModule", ["verifyStatusUpdate"]),
			/* funcao que foi passada para ca porque as infos estavam sendo passadas atraves de um if no compontente
			ai carregava tudo via mounted
			*/
			handleOpenMediaManager() {
				this.showMediaManager = true
			},
			closeTabs() {
				this.showMediaManager = false;
			},
			addPictures(pictures) {
				this.loadingMainImage = true;

				this.totalPost.thumbnail.mainImage = pictures[0].url;
				if (!this.customImagesCarousel.includes(pictures[0].url)) {
					this.customImagesCarousel.push(pictures[0].url);
				}
				
				this.showMediaManager = false;
				this.loadingMainImage = false;
			},
			moutedSettings() {
				this.getListPagesSimplified = [
					...this.getListPages.map(this.destructurePage),
				];
				this.categories = [...this.totalPost.categories];
				this.dates = { ...this.totalPost.dates };
				this.isAtHome = this.totalPost.isAtHome;
				this.isSchedulePost = this.validateSchedulePost();
				if (this.totalPost.pages.length > 0) {
					this.pages = [...this.totalPost.pages];
				} else if (this.getListPagesSimplified.length == 1) {
					this.pages.push(this.getListPagesSimplified[0]);
				}
				this.summary = this.totalPost.summary
					? this.totalPost.summary
					: this.createSummary();
				this.tags = [
					...this.totalPost.tags.map((tag) => ({
						text: tag.title,
						tiClasses: ["ti-valid"],
						id: tag.id,
					})),
				];
				this.sketch = this.totalPost.sketch;
				this.startPlace = this.totalPost.location;
				this.searchResponse.search = this.totalPost.location.address;
				this.visible = this.totalPost.visible;
				this.convertDates();
			},
			choiceSave(){
				console.log('this step', this.step)
				if(this.postType == "post" && this.step != 3){
					this.saveSketch();
				}
				else if(this.postType == "post" && this.step == 3){
					// this.saveSketch();
					setTimeout(() => {
						this.handleToSave();
					}, 200);
				}
				else{ // Para sections
					if(this.step == 1){
						console.log('save sketch')
						this.saveSketch()
					}
					else{
						console.log('save post')
						this.savePost()
					}
				}
			},
			isSelected(image){
				if(image == this.totalPost.thumbnail.mainImage ){
					return true
				}
				else return false
			},
			mainImage(image){
				return this.totalPost.thumbnail.mainImage = image;
			},
			checkDuplicateCategory() {
				return this.getCategories.some(
					(category) => category.title == this.newCategory.title
				);
			},
			mountImageUrl(image) {
				return `${process.env.CDN_URL}400x0/${image}`;
			},
			async changeThumbnail(indexCarouselPicture) {
				if (indexCarouselPicture > 0) {
					const imageSizes = await this.getImageSize(
						this.groupCarouselContent[indexCarouselPicture - 1]
					);
					if (this.newThumbnail != imageSizes) {
						this.newThumbnail = imageSizes;
						this.$store.dispatch(
							"dashboardModule/UPDATE_POST_THUMBNAIL",
							[imageSizes]
						);
					}
				}
			},
			getImageSize(imageUrl) {
				return new Promise((resolve, reject) => {
					const img = new Image();
					img.onload = function () {
						const thumbnail = {
							height: this.height,
							mainImage: imageUrl,
							width: this.width,
						};
						resolve(thumbnail);
					};
					img.src = this.mountImageUrl(imageUrl);
				});
			},
			handleActivePage(page) {
				if (
					this.pages.some((pg) => pg.value == page.id || pg.id == page.id)
				) {
					const pageIndex = this.pages.findIndex(
						(pg) => pg.value == page.id || pg.id == page.id
					);
					this.pages.splice(pageIndex, 1);
				} else {
					this.pages.push(page);
				}
			},
			cleanActivePage() {
				this.pages = [];
			},
			handleActiveCategory(element) {
				if (
					this.categories.some(
						(categorie) => categorie.title == element.title
					)
				) {
					const categorieIndex = this.categories.findIndex(
						(categorie) => categorie.title == element.title
					);
					this.categories.splice(categorieIndex, 1);
				} else {
					this.categories.push(element);
				}
			},
			toggleModalCategory() {
				this.$refs.modalCategory.toggle();
			},
			handleNewCategory(e) {
				this.newCategory.error = false;
				this.newCategory.textError = "";
				if (this.newCategory.title) {
					if (!this.checkDuplicateCategory()) {
						const newCategory = {
							id: null,
							title: this.newCategory.title,
						};
						this.$store.dispatch("dashboardModule/ADD_CATEGORY", [
							newCategory,
						]);
						this.handleActiveCategory(newCategory);
						this.$refs.modalCategory.toggle();
					} else {
						this.newCategory.textError = "Caregoria já cadastrada";
						this.newCategory.error = true;
					}
				} else {
					this.newCategory.textError = "Título obrigatório";
					this.newCategory.error = true;
				}
				e.preventDefault();
			},
			clearNewCategory() {
				this.newCategory.title = "";
				this.newCategory.textError = "";
				this.newCategory.error = false;
			},
			async removeCategory(item) {
				const siteId = this.$session.get("siteId");

				if (item.id) {
					const url = `/site/${siteId}/category/${item.id}/1/delete`;

					const { status } = await this.requestApiData(url, "post");

					status == '1' && this.$store.dispatch("dashboardModule/REMOVE_CATEGORY",[item]);
				} else {
					this.$store.dispatch("dashboardModule/REMOVE_CATEGORY",[
						item
					]);
				}
			},
			checkActivePage(id) {
				return this.pages.some((pg) => pg.value == id || pg.id == id)
					? "item-active"
					: "item--inactive";
			},
			checkActiveCategories(title) {
				return this.categories.some((categorie) => categorie.title == title)
					? "item-active"
					: "item--inactive";
			},
			destructurePage(page) {
				let { id, name } = page;
				const mapPage = {
					id: id,
					title: name,
				};
				return mapPage;
			},
			createSummary() {
				let content = this.contentPost[0].frameContent.find(
					(content) => content.frameType == "text"
				);
				if (!content || content.frameContent == null) {
					return "";
				} else {
					content = content.frameContent.replace(
						/(<([^>]+)>|(\&nbsp\;))/gi,
						""
					);
				}
				if (content.length > 200) {
					content = content.replace(
						/^([\s\S]{1,197})[\s]+?[\s\S]+/,
						"$1"
					);
					content = content + "...";
				}
				return content;
			},
			handleLocation() {
				if (this.newPlace.address) {
					return this.newPlace;
				} else {
					if (this.searchResponse.search == this.startPlace.address) {
						return this.startPlace;
					} else {
						const placeResult = {
							address_components: [],
							address: this.searchResponse.search,
							geometry: {
								location: {
									lat: null,
									lng: null,
								},
							},
						};
						return placeResult;
					}
				}
			},
			convertDates() {
				if (!this.dates.display_date) {
					setTimeout(() => {
						this.dates.display_date = new Date();
					}, 10);
				} else {
					setTimeout(() => {
						this.dates.display_date = new Date(
							this.dates.display_date.replace(/-/g, "/")
						);
					}, 10);
				}
			},
			async compressSettingsData() {
                this.dates.display_date = moment(this.dates.display_date).format(
                    "YYYY-MM-DD hh:mm:ss"
                );

                const updateData = {
                    categories: this.categories,
                    dates: this.dates,
                    isAtHome: this.isAtHome,
                    location: await this.handleLocation(),
                    pages: this.pages,
                    sketch: this.sketch,
                    summary: this.summary,
                    tags: this.tags.map((tag) => ({
                        id: tag.id || null,
                        title: tag.text,
                    })),
                    title: this.contentPost[0].frameContent,
                    visible: this.visible,
                };
                return updateData;
			},
			//Define o isSchedulePost e abre modal de agendamento.
			validateSchedulePost() {
				return new Promise(async (resolve) => {
					const today = moment(new Date()).format("YYYY-MM-DD");
					const toPublish = moment(this.dates.display_date).format(
						"YYYY-MM-DD"
					);
					const url = `/date/compare`;
					const formData = {
						first: toPublish,
						seccond: today,
					};
					const responseApi = await this.requestApiData(
						url,
						"post",
						formData
					);
					if(responseApi.data){
						this.isSchedulePost = true;
						if (this.modalSchedulePost.change > 2 && this.modalSchedulePost.show) {
							this.$bvModal
								.msgBoxOk(
									`Você adicionou uma data futura. Poderá publicar agora ou agendar para ${moment(
										toPublish
									).format("DD/MM/YYYY")} as 10am.`,
									{
										title: "Agendar publicação",
										modalClass: "full-white",
										size: "md",
										buttonSize: "sm",
										okTitle: "OK",
										footerClass: "p-2",
										hideHeaderClose: true,
										centered: true,
										noCloseOnBackdrop: true,
									}
								)
						}
						resolve(true);
					}
					else{
						this.isSchedulePost = false;
						resolve(false);
					}
					this.modalSchedulePost.show = false
				});
			},
			async handleToSave(date) {
                this.savingSketch = true;
				await this.validateSchedulePost();
				if(date === 'now'){
					this.isSchedulePost = false;
					const today = moment(new Date()).format("YYYY-MM-DD");
					this.dates.published_at = today;
				}
				if (this.isSchedulePost) {
					this.visible = 0;
				} else {
					this.visible = 1;
				}
				this.dates.scheduled = this.isSchedulePost ? 1 : 0;
				this.savePost();
			},
			async saveSketch() {
				this.verifyStatusUpdate(true)
				this.savingSketch = true;
				this.$emit("saving",this.savingSketch);
				this.$store.dispatch("dashboardModule/UPDATE_POST_SETTINGS", [
					await this.compressSettingsData(),
				]);
				const token = this.$session.get("jwt"),
					siteId = this.$store.state.dashboardModule.siteData.id,
					postId = parseInt(this.postId);
				this.totalPost.autoSave = 1;
				let masterOfPosts = {
					deletedFrames: this.deletedFrames,
					...this.totalPost,
				};
				const url = `/site/${siteId}/post/${postId}/update`;
				let responseApi = await this.requestApiData(
					url,
					"post",
					masterOfPosts
				);
				responseApi = await this.verifyStatusUpdate(false)
				this.savingSketch = false;
				this.$emit("saving",this.savingSketch);
				return responseApi
				// this.fetchPostContentBeforeUpdate();
			},
			async fetchPostContentBeforeUpdate() {
				const url = `/site/${this.$session.get("siteId")}/post/${
					this.postId
				}/edit`;
				let post = await this.requestApiData(url, "get");
				this.$store.dispatch("dashboardModule/getPostData", [post.data]);
				this.savingSketch = false;
				this.$emit("saving",this.savingSketch);
			},
			async savePost() {
				this.modalSchedulePost.show = true;
				this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [true]);
				this.sketch = 0;
				this.totalPost.autoSave = 0;
				const token = this.$session.get("jwt"),
					siteId = this.$store.state.dashboardModule.siteData.id,
					postId = parseInt(this.postId);
				this.$store.dispatch("dashboardModule/UPDATE_POST_SETTINGS", [
					await this.compressSettingsData(),
				]);
				let masterOfPosts = {
					deletedFrames: this.deletedFrames,
					...this.totalPost,
				};
				const url = `/site/${siteId}/post/${postId}/update`;
				const responseApi = await this.requestApiData(
					url,
					"post",
					masterOfPosts
				);
				this.saveCompleted = true;
				this.$store.dispatch("dashboardModule/UPDATE_CATEGORIES", [
					responseApi.categories,
				]);
				if (this.postType == "post" && this.pages.length > 0) {
					const firstPageSelected = this.getListPages.find(
						(page) => page.id == this.pages[0].id
					);
					if (firstPageSelected) {
						window.localStorage.setItem("activeCategory", firstPageSelected.id);
						window.localStorage.setItem(
							"activeCategoryRoute",
							firstPageSelected.route
						);
					}
				}
				this.savingSketch = false;
				this.$emit("saving",this.savingSketch);
				this.$router.push("/dashboard");
			},
		},
		async destroyed() {
            if (this.contentPost) {
                if (!this.saveCompleted) {
                    this.$store.dispatch("dashboardModule/UPDATE_POST_SETTINGS", [
                        await this.compressSettingsData(),
                    ]);
                } else {
                    this.$store.dispatch("dashboardModule/CLEAR_ACTIVE_POST");
                }
            }
		},
	};
</script>

<style scoped>
    .btn-fixed {
        transform: translateX(-50%);
        left: 50%;
        right: unset;
    }
	.icon-upload{
		height: 90px;
		width: 90px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: flex-end;
		justify-content: center;
		align-items: center;
	}
	.add-picture-gallery {
		border: 2px dashed #6828e83d;
		border-radius: 16px;
		align-self: center;
		border-radius: 8px;
		font-size: 30px;
		color: var(--main-color);
		transition: all 0.2s ease;
		position: relative;
	}
	.box-sendfile{
		background: #f7f7f7; color: #CECECE;
	}
	.box-sendfile{
		width: 100%; height: 100%;
	}
	.box-sendfile{
		flex-wrap: nowrap;
		flex-direction: column;
		min-width: 130px;
		width: 130px;
		margin-right: 4px;
		border-radius: 8px;
		border: none;
	}
</style>

<style>
	.select.active {
  		border: 3px solid var(--main-color);
	}
	.select{
		cursor: pointer;
	}
	.main-image{
		height: 80px;
    	border-radius: 8px;
		cursor: pointer;
	}
	#post-settings {
		padding: 2rem;
	}
	#post-settings label {
		color: #ccc;
		font-size: 0.8rem;
		font-family: "Open Sans", sans-serif;
		font-weight: 700;
	}
	#post-settings .photo.current img {
		border: 2px solid var(--main-color);
	}

	#post-settings input[type="checkbox"] + label {
		display: block;
		margin: 0.2em;
		cursor: pointer;
		padding: 0.2em;
	}

	#post-settings input[type="checkbox"] {
		display: none;
	}

	#post-settings input[type="checkbox"] + label:before {
		content: "\2714";
		border: 1px solid #000;
		border-radius: 0.2em;
		display: inline-block;
		width: 1.3rem;
		height: 1.3rem;
		padding-left: 0.3em;
		padding-bottom: 0.3em;
		margin-right: 10px;
		vertical-align: bottom;
		color: transparent;
		transition: 0.2s;
	}

	#post-settings input[type="checkbox"] + label:active:before {
		transform: scale(0.2);
	}

	#post-settings input[type="checkbox"]:checked + label:before {
		background-color: var(--main-color);
		border-color: var(--main-color);
		color: #fff;
	}

	#post-settings input[type="checkbox"]:disabled + label:before {
		transform: scale(1);
		border-color: #aaa;
	}

	#post-settings input[type="checkbox"]:checked:disabled + label:before {
		transform: scale(1);
		background-color: var(--main-color);
		border-color: var(--main-color);
	}
	#post-settings .boxsizingBorder {
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
	}
	#post-settings .toggle-button {
		color: var(--main-color);
	}
	.vue-tags-input[data-v-61d92e31] {
		max-width: 100%;
	}

	.vue-tags-input .ti-new-tag-input {
		background: transparent;
		color: #222222;
		font-size: 1rem;
	}

	.vue-tags-input .ti-input {
		padding: 4px 0px;
		transition: border-bottom 200ms ease;
	}

	/* we cange the border color if the user focuses the input */
	.vue-tags-input .ti-input {
		border: none;
	}

	/* some stylings for the autocomplete layer */
	.vue-tags-input .ti-autocomplete {
		background: #283944;
		border: 1px solid #8b9396;
		border-top: none;
	}

	/* the selected item in the autocomplete layer, should be highlighted */
	.vue-tags-input .ti-item.ti-selected-item {
		background: var(--main-color);
		color: #283944;
	}

	/* style the placeholders color across all browser */
	.vue-tags-input ::-webkit-input-placeholder {
		color: #a4b1b6;
	}

	.vue-tags-input ::-moz-placeholder {
		color: #a4b1b6;
	}

	.vue-tags-input :-ms-input-placeholder {
		color: #a4b1b6;
	}

	.vue-tags-input :-moz-placeholder {
		color: #a4b1b6;
	}

	/* default styles for all the tags */
	.vue-tags-input .ti-tag {
		position: relative;
		background: transparent;
		color: #222;
		border: 1px solid;
		border-color: var(--main-color);
		border-radius: 20px;
		padding-right: 8px;
		padding-left: 8px;
	}

	/* we defined a custom css class in the data model, now we are using it to style the tag */
	.vue-tags-input .ti-tag.custom-class {
		background: transparent;
		border: 1px solid var(--main-color);
		color: var(--main-color);
		margin-right: 4px;
		border-radius: 0px;
		font-size: 13px;
	}

	/* the styles if a tag is invalid */
	.vue-tags-input .ti-tag.ti-invalid {
		background-color: #4bbd2f;
	}

	/* if a tag or the user input is a duplicate, it should be crossed out */
	.ti-new-tag-input-wrapper .ti-duplicate{
    text-decoration: line-through;
  }

	/* if the user presses backspace, the complete tag should be crossed out, to mark it for deletion */
	.vue-tags-input .ti-tag:after {
		transition: transform 0.2s;
		position: absolute;
		content: "";
		height: 2px;
		width: 108%;
		left: -4%;
		top: calc(50% - 1px);
		background-color: #000;
		transform: scaleX(0);
	}

	.vue-tags-input .ti-deletion-mark:after {
		transform: scaleX(1);
	}

	.add-category-button {
		cursor: pointer;
		color: var(--main-color);
		font-size: 1.7rem;
	}

	.add-picture {
		width: 75px;
		height: 100px;
		border: 2px dashed #6828e83d;
		border-radius: 4px;
		font-size: 30px;
		color: var(--main-color);
		display: flex;
		justify-content: center;
		align-items: center;
	}
	#post-settings .carousel-3d-slide img {
		max-height: 100px;
		object-fit: cover;
	}
</style>



// WEBPACK FOOTER //
// src/components/organisms/PostEditorSettings.vue